import { DynamicFormRequiredType, type DynamicFormSettings } from '@myosh/odin-components';
import i18next from '../../i18n';
import { UserFields } from '../../utils/user-config';
import { emailValidation, passwordValidation } from '../admin/user/user-form-settings';
import HfPasswordField from '../fields/password-field/hf-password-field.component';

export const getRegistrationFormSettings = (): DynamicFormSettings => {
  return {
    id: 0,
    caption: '',
    fields: [
      {
        id: 100,
        fieldType: 'GROUP',
        fieldName: 'Account Details',
        caption: i18next.t('account-details'),
        position: 0,
        startOpen: true,
        permissions: { read: true, edit: true },
        fields: [
          {
            id: UserFields.firstName,
            fieldType: 'TEXTFIELD',
            fieldName: UserFields.firstName,
            caption: i18next.t('first-name'),
            required: DynamicFormRequiredType.True,
            position: 0,
          },
          {
            id: UserFields.lastName,
            fieldType: 'TEXTFIELD',
            fieldName: UserFields.lastName,
            caption: i18next.t('last-name'),
            required: DynamicFormRequiredType.True,
            position: 1,
          },
          {
            id: UserFields.email,
            fieldType: 'CUSTOM',
            customFieldType: 'TEXTFIELD',
            fieldName: UserFields.email,
            caption: i18next.t('email'),
            required: DynamicFormRequiredType.True,
            position: 2,
            validationFunc: emailValidation(i18next.t('email')),
          },
          {
            id: UserFields.password,
            fieldType: 'CUSTOM',
            customFieldType: 'PASSWORDFIELD',
            fieldName: UserFields.password,
            caption: i18next.t('password'),
            position: 3,
            required: DynamicFormRequiredType.True,
            validationFunc: passwordValidation(i18next.t('password'), false),
          },
          {
            id: UserFields.retypePassword,
            fieldType: 'CUSTOM',
            customFieldType: 'PASSWORDFIELD',
            fieldName: UserFields.retypePassword,
            caption: i18next.t('retype-password'),
            position: 4,
            required: DynamicFormRequiredType.True,
            validationFunc: passwordValidation(i18next.t('retype-password'), true),
          },
        ],
      },
    ],
    customFieldComponents: {
      PASSWORDFIELD: HfPasswordField,
    },
  };
};
